// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails";
import "./controllers";
import "chartkick/chart.js";

// Handle smooth scrolling for anchor links stored from cross-page clicks
document.addEventListener("turbo:load", () => {
  const hash = sessionStorage.getItem("scrollToHash");
  if (hash) {
    sessionStorage.removeItem("scrollToHash");
    try {
      const decodedHash = decodeURIComponent(hash);
      const target = document.querySelector(decodedHash);
      if (target) {
        // Reset scroll position to top instantly so we can animate scroll down
        window.scrollTo(0, 0);
        // Smooth scroll to the target element
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 50);
      }
    } catch (e) {
      // Ignore errors if target selector is invalid
    }
  }
});
